//Archivo dedicado al menu de todos los imports de Notificadores

//Imports relacionados de Notificadores
//-----------Principal-----------
import Plantilla from '@/components/SINOJ/Comun/Plantilla.vue';

//-----------Consulta-----------
import CMenuConsultas from '@/components/SINOJ/Consultas/CMenuConsultas.vue';
//-----------Dirección-----------
import ConsultaDireccion from '@/components/SINOJ/Consultas/ConsultaDireccion/ConsultaDireccion.vue';
import DetallesConsultaDireccion from '@/components/SINOJ/Consultas/ConsultaDireccion/DetallesCedula.vue';
import HistorialDeAcuerdoConsultaDireccion from '@/components/SINOJ/Consultas/ConsultaDireccion/HistorialAcuerdo.vue';
import CReporteDeCedulasEnviadasAJuzgado from '@/components/SINOJ/Reportes/ReportesDeDireccion/CReporteDeCedulasEnviadasAJuzgado.vue';
import CBitacoraCedulasAnteriores from '@/components/SINOJ/Consultas/BitacoraCedulasAnteriores/CBitacoraCedulasAnteriores.vue';

//-----------Juzgado-----------
import ConsultaJuzgado from '@/components/SINOJ/Consultas/ConsultaJuzgado/ConsultaJuzgado.vue';
import DetallesConsultaJuzgado from '@/components/SINOJ/Consultas/ConsultaJuzgado/DetallesCedula.vue';
import CReporteDeCedulasEnviadasADireccion from '@/components/SINOJ/Reportes/ReportesDeJuzgado/CReporteDeCedulasEnviadasADireccion.vue';
import CReporteDeCedulasCreadasEnJuzgado from '@/components/SINOJ/Reportes/ReportesDeJuzgado/CReporteDeCedulasCreadasEnJuzgado.vue';
//-----------Público-----------
import ConsultaPublica from '@/components/SINOJ/Consultas/ConsultaPublica/ConsultaPublica.vue';
import DetallesConsultaPublica from '@/components/SINOJ/Consultas/ConsultaPublica/DetallesCedula.vue';
//-----------Salidas del día-----------
import ConsultaSalidasDelDia from '@/components/SINOJ/Consultas/SalidasDelDia/ConsultaSalidasDelDia.vue';

//-----------Cédulas-----------
import CMenuCedulas from '@/components/SINOJ/Cedulas/CMenuCedulas.vue'
import CCancelacionDeCedula from '@/components/SINOJ/Cedulas/ManejoDeCedulas/Cancelacion/CCancelacionDeCedula.vue'
import CEmplazamientoDeCedula from '@/components/SINOJ/Cedulas/ManejoDeCedulas/Emplazamiento/CEmplazamientoDeCedula.vue'
import CEnvioDeCedulas from '@/components/SINOJ/Cedulas/EnvioAJuzgado/CEnvioDeCedulas.vue'
import CCedulasEnviadas from '@/components/SINOJ/Cedulas/EnvioAJuzgado/CCedulasEnviadas.vue'
/* import CAsignacionDeCedulasANotificador from '@/components/SINOJ/Cedulas/ManejoDeCedulas/AsignarNotificador/CAsignacionDeCedulasANotificador.vue' */
import CAsignacionDeCedulas from '@/components/SINOJ/Cedulas/ManejoDeCedulas/AsignarNotificador/v2/CAsignacionDeCedulas.vue'
import CCreacionDeCedula from '@/components/SINOJ/Cedulas/Creacion/CCreacionDeCedula.vue'
import CCorreccionCedulaConResultado from '@/components/SINOJ/Cedulas/ManejoDeCedulas/CorreccionConResultado/CCorreccionCedulaConResultado.vue'
import CCorreccionCedulaSinResultado from '@/components/SINOJ/Cedulas/ManejoDeCedulas/CorreccionSinResultado/CCorreccionCedulaSinResultado.vue'
import CReporteCedulasEnviadas from '@/components/SINOJ/Cedulas/EnvioAJuzgado/Reportes/CReporteCedulasEnviadas.vue'

import CCreacionCedula from '@/components/SINOJ/Cedulas/Creacion/V2/CCreacionCedula.vue'

//-----------Administracion-----------
import CMenuAdministracion from '@/components/SINOJ/Administracion/CMenuAdministracion.vue'
import CRegistroDeEmpresaNotificacion from '@/components/SINOJ/Administracion/Empresas/CRegistroDeEmpresaNotificacion.vue'
import CZonas from '@/components/SINOJ/Administracion/Zonas/CZonas.vue'
import CFraccionamientos from '@/components/SINOJ/Administracion/Fraccionamientos/CFraccionamientos.vue'
import CNotificadores from '@/components/SINOJ/Administracion/Notificadores/CNotificadores.vue'
import CPlantillas from '@/components/SINOJ/Administracion/Plantillas/CPlantillas.vue'

//-----------Notificaciones-----------
import CMenuNotificaciones from '@/components/SINOJ/Notificaciones/CMenuNotificaciones.vue'
import CSalidasDelDia from '@/components/SINOJ/Notificaciones/CedulasParaSalida/CSalidasDelDia.vue'
import CSalidasDeNotificador from '@/components/SINOJ/Notificaciones/CedulasParaSalida/CSalidasDeNotificador.vue'
import CResultados from '@/components/SINOJ/Notificaciones/Resultados/CResultados.vue'
import CResultadosCitatorio from '@/components/SINOJ/Notificaciones/Resultados/ResultadoCitatorio.vue'
import CEdicionDeResultado from '@/components/SINOJ/Notificaciones/Resultados/Edicion/CEdicionDeResultado.vue'
import CAnexo from '@/components/SINOJ/Notificaciones/Resultados/Edicion/CAnexo.vue'
import CReporteCedulasDeNotificador from '@/components/SINOJ/Reportes/ReportesDeNotificadores/CReporteCedulasDeNotificador.vue';
import CAnexosDeConstituciones from '@/components/SINOJ/Notificaciones/Constituciones/CAnexosDeConstituciones.vue'
import CCreacionDeDocumentoResultadosPrevios from '@/components/SINOJ/Notificaciones/CreacionDeDocumentos/CCreacionDeDocumentoResultadosPrevios.vue'

//-----------Reportes-----------------
import CMenuReportes from '@/components/SINOJ/Reportes/CMenuReportes.vue'

//Se crea la lista de paths
const SINOJ = [
  {
    name: 'SINOJ', path: '/SINOJ/', component: Plantilla, meta: { tituloDeLaPagina: "Sistema de Notificadores", RequiereAutenticacion: true, ValidaSesion: true, ObtenDatos: true, ObtenPermisosDelSistema: true, SistemaQueSeIngreso: 27 }, children: [
      { name: 'MenuConsultas', path: 'Consultas', component: CMenuConsultas, meta: { tituloDeLaPagina: "Modulo de consultas de información", RequiereAutenticacion: true, ValidaSesion: true, ObtenDatos: true, ObtenPermisosDelSistema: true, SistemaQueSeIngreso: 27, ModuloId: 2 } },
      { name: 'ConsultaDireccion', path: 'Consultas/ConsultaDireccion', component: ConsultaDireccion, meta: { tituloDeLaPagina: "Consulta para Dirección", RequiereAutenticacion: true, ValidaSesion: true, ObtenDatos: true, ObtenPermisosDelSistema: true, SistemaQueSeIngreso: 27, ModuloId: 2, FuncionId: 1 } },
      { name: 'DetallesConsultaDireccion', path: 'Consultas/DetallesConsultaDireccion/:folio?', props: true, component: DetallesConsultaDireccion, meta: { tituloDeLaPagina: "Consulta para Dirección", RequiereAutenticacion: true, ValidaSesion: true, ObtenDatos: true, ObtenPermisosDelSistema: true, SistemaQueSeIngreso: 27, ModuloId: 2, FuncionId: 1 } },
      { name: 'HistorialDeAcuerdoConsultaDireccion', path: 'Consultas/HistorialDeAcuerdoConsultaDireccion/:folio?', props: true, component: HistorialDeAcuerdoConsultaDireccion, meta: { tituloDeLaPagina: "Historial de Acuerdo para Dirección", RequiereAutenticacion: true, ValidaSesion: true, ObtenDatos: true, ObtenPermisosDelSistema: true, SistemaQueSeIngreso: 27, ModuloId: 2, FuncionId: 1 } },
      { name: 'ConsultaJuzgado', path: 'Consultas/ConsultaJuzgado', props: true, component: ConsultaJuzgado, meta: { tituloDeLaPagina: "Consulta para Juzgado", RequiereAutenticacion: true, ValidaSesion: true, ObtenDatos: true, ObtenPermisosDelSistema: true, SistemaQueSeIngreso: 27, ModuloId: 2, FuncionId: 2 } },
      { name: 'DetallesConsultaJuzgado', path: 'Consultas/DetallesConsultaJuzgado/:folio?', props: true, component: DetallesConsultaJuzgado, meta: { tituloDeLaPagina: "Consulta para Juzgado", RequiereAutenticacion: true, ValidaSesion: true, ObtenDatos: true, ObtenPermisosDelSistema: true, SistemaQueSeIngreso: 27, ModuloId: 2, FuncionId: 2 } },
      { name: 'ConsultaPublica', path: 'Consultas/ConsultaPublica', props: true, component: ConsultaPublica, meta: { tituloDeLaPagina: "Consulta para Pública", RequiereAutenticacion: true, ValidaSesion: true, ObtenDatos: true, ObtenPermisosDelSistema: true, SistemaQueSeIngreso: 27, ModuloId: 2, FuncionId: 3 } },
      { name: 'DetallesConsultaPublica', path: 'Consultas/DetallesConsultaPublica/:folio?', props: true, component: DetallesConsultaPublica, meta: { tituloDeLaPagina: "Consulta para Pública", RequiereAutenticacion: true, ValidaSesion: true, ObtenDatos: true, ObtenPermisosDelSistema: true, SistemaQueSeIngreso: 27, ModuloId: 2, FuncionId: 3 } },
      { name: 'ConsultaSalidasDelDia', path: 'Consultas/ConsultaSalidasDelDia', component: ConsultaSalidasDelDia, meta: { tituloDeLaPagina: "Consulta para Salidas del Día", RequiereAutenticacion: true, ValidaSesion: true, ObtenDatos: true, ObtenPermisosDelSistema: true, SistemaQueSeIngreso: 27, ModuloId: 2, FuncionId: 4 } },
      { name: 'MenuCedulas', path: 'Cedulas', component: CMenuCedulas, meta: { tituloDeLaPagina: "Modulo para la administración de cedulas", RequiereAutenticacion: true, ValidaSesion: true, ObtenDatos: true, ObtenPermisosDelSistema: true, SistemaQueSeIngreso: 27, ModuloId: 1 } },
      { name: 'CancelacionDeCedula',
        path: 'Cedulas/CancelacionDeCedula',
        component: CCancelacionDeCedula, 
        meta: { 
          tituloDeLaPagina: "Cancelación de cédula",
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 27, 
          ModuloId: 1, 
          FuncionId: 11 
        } 
      },
      { name: 'EmplazamientoDeCedula', 
        path: 'Cedulas/EmplazamientoDeCedula', 
        component: CEmplazamientoDeCedula, 
        meta: { 
          tituloDeLaPagina: "Emplazamiento de cédula", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 27, 
          ModuloId: 2, 
          FuncionId: 2 
        }
      },
      { name: 'EnvioDeCedulas', 
        path: 'Cedulas/EnvioDeCedulas', 
        component: CEnvioDeCedulas, 
        meta: { 
          tituloDeLaPagina: "Envío de cédula a juzgado", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 27, 
          ModuloId: 1, 
          FuncionId: 16 
        }
      },
      { name: 'CedulasEnviadas', 
        path: 'Cedulas/CedulasEnviadas', 
        component: CCedulasEnviadas, 
        meta: { 
          tituloDeLaPagina: "Cédula enviadas por juzgado a área de notificación", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 27, 
          ModuloId: 2, 
          FuncionId: 2 
        }
      },
      { name: 'ReporteEnvioDeCedulas', 
        path: 'Cedulas/CedulasEnviadas/:idReporte', 
        component: CReporteCedulasEnviadas, 
        meta: { 
          tituloDeLaPagina: "Reporte de cédulas enviadas", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 27, 
          ModuloId: 2, 
          FuncionId: 2 
        }
      },
      { name: 'AsignacionDeCedulasANotificador', 
        path: 'Cedulas/AsignacionDeCedulasANotificador', 
        component: CAsignacionDeCedulas, 
        meta: { 
          tituloDeLaPagina: "Asignación de cédulas a notificador", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 27, 
          ModuloId: 1, 
          FuncionId: 12 
        }
      },
      { name: 'CreacionDeCedula', 
        path: 'Cedulas/CreacionDeCedula', 
        component: CCreacionDeCedula,
        props: true,
        meta: { 
          tituloDeLaPagina: "Creación de cédula", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 27, 
          ModuloId: 1, 
          FuncionId: 10 
        }
      },
      { name: 'CorrecionDeCedulaConResultado', 
        path: 'Cedulas/CorrecionDeCedulaConResultado', 
        component: CCorreccionCedulaConResultado, 
        meta: { 
          tituloDeLaPagina: "Correción de cédula con resultado", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 27, 
          ModuloId: 1, 
          FuncionId: 14 
        }
      },
      { name: 'CorrecionDeCedulaSinResultado', 
        path: 'Cedulas/CorrecionDeCedulaSinResultado', 
        component: CCorreccionCedulaSinResultado, 
        meta: { 
          tituloDeLaPagina: "Correción de cédula con resultado", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 27, 
          ModuloId: 1, 
          FuncionId: 15 
        }
      },
      { name: 'MenuAdministracion', path: 'Administracion', component: CMenuAdministracion, meta: { tituloDeLaPagina: "Modulo para la administración del sistemas", RequiereAutenticacion: true, ValidaSesion: true, ObtenDatos: true, ObtenPermisosDelSistema: true, SistemaQueSeIngreso: 27, ModuloId: 3 } },
      { name: 'RegistroDeEmpresa', 
        path: 'Administracion/RegistroDeEmpresa', 
        component: CRegistroDeEmpresaNotificacion, 
        meta: { 
          tituloDeLaPagina: "Registro de empresa para notificación", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 27, 
          ModuloId: 3, 
          FuncionId: 17 
        }
      },
      { name: 'Fraccionamientos', 
        path: 'Administracion/Fraccionamientos', 
        component: CFraccionamientos, 
        meta: { 
            tituloDeLaPagina: "Administración de fraccionamientos", 
            RequiereAutenticacion: true, 
            ValidaSesion: true, 
            ObtenDatos: true, 
            ObtenPermisosDelSistema: true, 
            SistemaQueSeIngreso: 27, 
            ModuloId: 3, 
            FuncionId: 6 
          }
      },
      { name: 'Notificadores', 
        path: 'Administracion/Notificadores', 
        component: CNotificadores, 
        meta: { 
            tituloDeLaPagina: "Administración de notificadores", 
            RequiereAutenticacion: true, 
            ValidaSesion: true, 
            ObtenDatos: true, 
            ObtenPermisosDelSistema: true, 
            SistemaQueSeIngreso: 27, 
            ModuloId: 3, 
            FuncionId: 7 
          }
      },
      { name: 'Zonas', 
        path: 'Administracion/Zonas', 
        component: CZonas, 
        meta: { 
          tituloDeLaPagina: "Administración de zonas", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 27, 
          ModuloId: 3, 
          FuncionId: 5 
        }
      },
      { name: 'Plantillas', 
        path: 'Administracion/Plantillas', 
        component: CPlantillas, 
        meta: { 
          tituloDeLaPagina: "Administración de plantillas para documentos", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 27, 
          ModuloId: 3, 
          FuncionId: 18 
        }
      },
      { name: 'MenuNotificaciones', path: 'Notificaciones', component: CMenuNotificaciones, meta: { tituloDeLaPagina: "Modulo para Notificaciones", RequiereAutenticacion: true, ValidaSesion: true, ObtenDatos: true, ObtenPermisosDelSistema: true, SistemaQueSeIngreso: 27, ModuloId: 4 } },
      { name: 'SalidasDelDia', 
        path: 'Notificaciones/SalidasDelDia', 
        props: true,
        component: CSalidasDelDia, 
        meta: { 
          tituloDeLaPagina: "Salidas del día", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 27, 
          ModuloId: 4, 
          FuncionId: 8 
        }
      },
      { name: 'SalidasDeNotificador', 
        path: 'Notificaciones/SalidasDeNotificador/:idNotificador?', 
        props: true,
        component: CSalidasDeNotificador, 
        meta: { 
          tituloDeLaPagina: "Salidas del notificador", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 27, 
          ModuloId: 4, 
          FuncionId: 8 
        }
      },
      { name: 'AnexosParaConstitucionDeCedula', 
        path: 'Notificaciones/AnexosParaConstitucionDeCedula', 
        component: CAnexosDeConstituciones, 
        meta: { 
          tituloDeLaPagina: "Anexos para constitución de cédula", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 27, 
          ModuloId: 4, 
          FuncionId: 23 
        }
      },
      { name: 'Resultados', 
        path: 'Notificaciones/Resultados', 
        props: true,
        component: CResultados, 
        meta: { 
          tituloDeLaPagina: "Resultados a cédulas pendientes", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 27, 
          ModuloId: 4, 
          FuncionId: 9 
        }
      },      
      { name: 'ResultadoCitatorio', 
        path: 'Notificaciones/ResultadoCitatorio', 
        props: true,
        component: CResultadosCitatorio, 
        meta: { 
          tituloDeLaPagina: "Resultados a cédulas de citatorio", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 27, 
          ModuloId: 4, 
          FuncionId: 9 
        }
      },
      { name: 'DocumentoResultadosPrevios', 
        path: 'Notificaciones/DocumentosDeResultados', 
        props: true,
        component: CCreacionDeDocumentoResultadosPrevios, 
        meta: { 
          tituloDeLaPagina: "Documentos De Resultados", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 27, 
          ModuloId: 4, 
          FuncionId: 24 
        }
      },
      { name: 'EdicionResultado', 
        path: 'Notificaciones/Resultados/Edicion/:folio?', 
        props: true,
        component: CEdicionDeResultado, 
        meta: { 
          tituloDeLaPagina: "Edición de resultado", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 27, 
          ModuloId: 4, 
          FuncionId: 9 
        }
      },
      { name: 'Anexo', 
        path: 'Notificaciones/Resultados/Edicion/Anexo/:idCedula?', 
        component: CAnexo, 
        props: true,
        meta: { 
          tituloDeLaPagina: "Anexo de cédula", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 27, 
          ModuloId: 4, 
          FuncionId: 9 
        }
      },
      { name: 'MenuReportes', path: 'Reportes', component: CMenuReportes, meta: { tituloDeLaPagina: "Modulo para la generacion de reportes del sistemas", RequiereAutenticacion: true, ValidaSesion: true, ObtenDatos: true, ObtenPermisosDelSistema: true, SistemaQueSeIngreso: 27, ModuloId: 5 } },
      { name: 'ReporteDeCedulasEnviadasAJuzgado', 
        path: 'Reportes/ReporteDeCedulasEnviadasAJuzgado', 
        component: CReporteDeCedulasEnviadasAJuzgado,
        meta: { 
          tituloDeLaPagina: "Reporte de cédulas enviadas a juzgado", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 27, 
          ModuloId: 5, 
          FuncionId: 20 
        }
      },
      { name: 'ReporteDeCedulasEnviadasADireccion', 
        path: 'Reportes/ReporteDeCedulasEnviadasADireccion', 
        component: CReporteDeCedulasEnviadasADireccion,
        meta: { 
          tituloDeLaPagina: "Reporte de cédulas enviadas a dirección de notificadores", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 27, 
          ModuloId: 5, 
          FuncionId: 21 
        }
      },
      { name: 'ReporteDeCedulasCreadasEnJuzgado', 
        path: 'Reportes/ReporteDeCedulasCreadasEnJuzgado', 
        component: CReporteDeCedulasCreadasEnJuzgado,
        meta: { 
          tituloDeLaPagina: "Reporte de cédulas creadas en juzgado", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 27, 
          ModuloId: 5, 
          FuncionId: 26 
        }
      },
      { name: 'ReporteCedulasDeNotificador', 
        path: 'Reportes/ReporteCedulasDeNotificador', 
        component: CReporteCedulasDeNotificador,
        meta: { 
          tituloDeLaPagina: "Reporte de cédulas de notificador", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 27, 
          ModuloId: 5, 
          FuncionId: 22 
        }
      },
      { name: 'BitacoraCedulasAnteriores', 
        path: 'Consultas/BitacoraDeCedulasAnteriores', 
        component: CBitacoraCedulasAnteriores,
        meta: { 
          tituloDeLaPagina: "Bitacora de cédulas anteriores", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 27, 
          ModuloId: 2, 
          FuncionId: 25
        }
      },
      { name: 'Creacion de cedula v2', 
        path: 'Creacion/v2', 
        component: CCreacionCedula,
        meta: { 
          tituloDeLaPagina: "Creación de cédula", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 27, 
          ModuloId: 1, 
          FuncionId: 10 
        }
      }
    ]
  }
]

//Se regresa la lista de paths
export default SINOJ;



// WEBPACK FOOTER //
// ./src/router/SINOJ.js